import * as Yup from 'yup'

export const PHONE_REGEX =
  /^[|+]?[(]?[0-9]{3}[)]?[-\s|.]?[0-9]{3}[-\s|.]?[0-9]{4,6}$/

export const ZIP_CODE_MAX_LENGTH = 20

const getYupStringObjectWithLabel = (label) => Yup.string().label(label)
const isoCodeYupObject = Yup.mixed().label('Country').nullable()
const stateValueYupObject = getYupStringObjectWithLabel('State')
const cityValueYupObject = getYupStringObjectWithLabel('City')

export const locationSchema = ({
  countryFieldName = 'country',
  stateFieldName = 'state',
  cityFieldName = 'city',
  isWithCity = true,
  isRequired = true,
} = {}) => ({
  [countryFieldName]: Yup.object().shape({
    isoCode: isRequired
      ? isoCodeYupObject.required('Country is a required field')
      : isoCodeYupObject,
  }),
  [stateFieldName]: Yup.object().when(countryFieldName, {
    is: ({ isoCode }) => isoCode === 'us',
    then: Yup.object().shape({
      value: isRequired
        ? stateValueYupObject.required('State is a required field')
        : stateValueYupObject,
    }),
  }),
  ...(isWithCity
    ? {
        [cityFieldName]: Yup.object().shape({
          value: isRequired
            ? cityValueYupObject.required('City is a required field')
            : cityValueYupObject,
        }),
      }
    : {}),
})

export const productQuantitySchema = ({
  fieldName,
  minimumOrderQuantity,
  availableQuantity,
  leadTime,
}) =>
  Yup.number()
    .min(1)
    .required()
    .test({
      name: fieldName,
      message: 'Invalid quantity selected',
      test: (value) =>
        value > 0 &&
        value >= minimumOrderQuantity &&
        (leadTime || value <= availableQuantity),
    })
